import { motion } from 'motion/react';
import { C } from '../../constants/colors.js';
import { N } from '../../constants/fonts.js';
import { tapBounce } from '../../lib/motionPresets.js';

function getTimeEstimate(age) {
  if (typeof age !== 'number') return 'This takes about 5-10 minutes';
  if (age >= 4 && age <= 5) return 'This takes about 5 minutes';
  if (age >= 6 && age <= 8) return 'This takes about 7 minutes';
  if (age >= 9 && age <= 12) return 'This takes about 10 minutes';
  return 'This takes about 5-10 minutes';
}

export function PlacementBriefing({ age, onStart, onSkip }) {
  const estimate = getTimeEstimate(age);
  const bullets = [
    "Let your child answer on their own. If they ask for help, say: 'Just try your best!'",
    'Sit nearby for comfort, but let them tap the answers',
    'There are no wrong answers. Every response helps Finley build the perfect path'
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25 }}
      className="mx-auto flex min-h-full w-full max-w-xl flex-col justify-center px-6 py-8"
    >
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25 }}
        className="mb-5 flex min-h-[180px] items-center justify-center"
      >
        <div
          className="flex h-36 w-36 items-center justify-center rounded-full border-2 shadow-finley-sm"
          style={{ background: `${C.primary}12`, borderColor: `${C.primary}2E` }}
        >
          <span style={{ fontSize: 72 }}>🐬</span>
        </div>
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, delay: 0.22 }}
        className="mb-4 text-center font-finley-display text-4xl text-finley-text"
      >
        Let's find your child's starting adventure!
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, delay: 0.44 }}
        className="mb-5 rounded-finley-lg bg-finley-bg-card px-5 py-4 shadow-finley-sm"
      >
        {bullets.map((item, idx) => (
          <div key={idx} className="mb-3 flex items-start gap-3 last:mb-0">
            <span className="mt-0.5 text-base text-finley-success">✓</span>
            <p className="m-0 text-sm leading-6 text-finley-text-light">{item}</p>
          </div>
        ))}
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.25, delay: 0.64 }}
        className="mb-2 text-center text-sm text-finley-text-light"
      >
        {estimate}
      </motion.p>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.25, delay: 0.82 }}
        className="mb-6 text-center text-xs leading-5 text-finley-text-muted"
      >
        Finley often starts a little below to build confidence. The path adjusts quickly as your child plays.
      </motion.p>

      <motion.button
        {...tapBounce}
        onClick={onStart}
        className="min-h-[52px] w-full rounded-finley-lg bg-finley-primary px-6 py-3 font-finley-display text-base text-white shadow-finley-md"
      >
        We're ready, let's start!
      </motion.button>

      <button
        onClick={onSkip}
        className="mt-4 text-center text-xs text-finley-text-muted underline decoration-transparent underline-offset-2 transition hover:decoration-finley-text-muted"
        style={{ fontFamily: N }}
      >
        Skip and let Finley start from the beginning
      </button>
    </motion.div>
  );
}
